/**
 * Created by Rodrigo Quesada on 16/02/17.
 */
import {Component} from '@angular/core';
import {AccordionScreen} from '../../../shared/step/accordion/accordion-screen.class';
import {ContinuingMedicalEducation} from '../../../../domain/model/licenses-certifications/cme/continuing-medical-education.model';
import {ContinuingMedicalEducationService} from '../../../../domain/model/licenses-certifications/cme/continuing-medical-education.service';
import {EntryWithSupportingDocument} from '../../../shared/step/accordion/entry.class';
import {FileListComponentModel} from '../../../../components/files/file-list/file-list.component';
import {Model} from '../../../../domain/model/common/model.class';
import {FileUploaderComponentModel} from '../../../../components/files/file-uploader/file-uploader.component';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {RolesAware} from '../../../../domain/authorization/roles-aware.class';
import {MixinConstructor} from '../../../../common/mixins/mixins';
import {ContinuingMedicalEducationInformationService} from '../../../../domain/model/licenses-certifications/cme/continuing-medical-education-information.service';
import {ContinuingMedicalEducationInformation} from '../../../../domain/model/licenses-certifications/cme/continuing-medical-education-information.model';
import {AuthService} from '../../../../components/security/authorization/auth.service';
import {Roles} from '../../../../domain/authorization/roles';
import {FileListService} from '../../../../components/files/service/file-list.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;

//region Other Classes
class ContinuingMedicalEducationEntry extends EntryWithSupportingDocument<ContinuingMedicalEducation> {
    constructor(esdm: EntryWithSupportingDocument.InjectedMembers, model: ContinuingMedicalEducation) {
        super(esdm, model, 'continuingMedicalEducation');
    }
}
//endregion

@Component({
    template: require('./continuing-medical-education-screen.component.html'),
    styles: [require('./continuing-medical-education-screen.component.scss')]
})
export class ContinuingMedicalEducationScreenComponent extends RolesAware(AccordionScreen as MixinConstructor<AccordionScreen<ContinuingMedicalEducationEntry, ContinuingMedicalEducation>>) {

    constructor(esdm: EntryWithSupportingDocument.InjectedMembers,
                modelService: ContinuingMedicalEducationService,
                private readonly _modelInfoService: ContinuingMedicalEducationInformationService,
                private readonly _fileListService: FileListService,
                private readonly _fileLocationFactory: FileLocationFactory,
                _authService: AuthService) {

        super(ContinuingMedicalEducation, (m) => new ContinuingMedicalEducationEntry(esdm, m), 'issuingEntity', modelService);

        _modelInfoService.getCurrentUserModel().subscribe(it => this.infoModel = it);

        this.fileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());

        _authService.user$.map(user => user !== undefined && user.hasAnyRole([Roles.ADMIN]))
            .subscribe(hasRoles => this._userIsAdmin = hasRoles);
    }

    infoModel: ContinuingMedicalEducationInformation = new ContinuingMedicalEducationInformation();

    creditsMask = [/\d/, /\d/, /\d/];

    completionDateConstrains = {
        min: moment().subtract(100, 'year'),
        max: moment().add(5, 'year')
    };

    fileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this._fileLocationFactory.create('continuingMedicalEducationInfo', 'currentUser', new ProjectionInformation('file'))
    });

    fileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this._fileLocationFactory.create('continuingMedicalEducationInfo', 'currentUser', new ProjectionInformation('files'))
    });

    private _refreshFilesInfo() {
        this._fileListService.list(this.fileUploaderModel.filesLocation).subscribe(files => this.fileListModel.files = files);
    }

    changeEditableByRegularUser(value: boolean) {
        this.infoModel.editableByRegularUser = value;
        this._modelInfoService.updateCurrentUserModel(this.infoModel).subscribe();
    }

    private _userIsAdmin: boolean = false;

    get displayManageSection(): boolean {
        return this._userIsAdmin || this.infoModel.editableByRegularUser;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/cme/continuing-medical-education-screen.component.ts